import { create } from "../../../../../common/utils/zustand_state_manager";
import { SetFunction, SetFunctionImpl } from "../../../../../common/utils/filters_utils";

type State = {
  IdContrato: number;
  IdContratoInformacoes: number;
  Data: Date | null;
  DescInformacoes: string | null;

};

type Action = {
  setFilters: (filters: Partial<State>) => void;
  clearFilters: () => void;
  setIdContrato: SetFunction<number>;
  setIdContratoInformacoes: SetFunction<number>;
  setData: SetFunction<Date>;
  setDescInformacoes: SetFunction<string>;
};

export const initialFiltersValues: State = {
  IdContrato: 0,
  IdContratoInformacoes: 0,
  Data: null,
  DescInformacoes: null,

};

export const useContratoInformacoesFilters = create<State & Action>((set) => ({
  ...initialFiltersValues,
  setIdContrato: (vfn) => SetFunctionImpl(set, 'IdContrato', vfn),
  setData: (vfn) => SetFunctionImpl(set, 'Data', vfn),
  setDescInformacoes: (vfn) => SetFunctionImpl(set, 'DescInformacoes', vfn),
  setIdContratoInformacoes: (vfn) => SetFunctionImpl(set, 'IdContratoInformacoes', vfn),
  setFilters: (filters) => set((state) => ({ ...state, ...filters })),
  clearFilters: () => set((state) => ({
    ...initialFiltersValues,
  })),
}));